<template>
  <div>
    <viewer ref="imageViewer" v-if="attachType==='image'" 
      :options="options" style="height:600px" @inited="inited">
      <img :src="imagePath" style="display:none">
    </viewer>
    <!-- <a ref="downloadObj"></a> -->
    <el-dialog
      id="file-previewer"
      key="file-previewer"
      title="文件预览" top='8vh'
      :visible.sync="pdfViewerVisible"
      height="calc(100vh - 100px)"
      :modal="false"
      width="80%" @closed="$parent.attachViewerVisible=false">
      <iframe name="pdfViewer"  v-if="attachType==='pdf'"
        ref="pdfViewer"
        :src="pdfPath"
        height="600vh"
        width="100%"/>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pdfViewerVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  fileInfo,
  downloadFile
} from '@/api/largeFile.js'
import { component as Viewer } from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import extendFunctions from '@/views/Report/ReportEditor/js/extend.js'
export default {
  name: 'AttachPreview',
  data() {
    return {
      previewAttachInfo: {},
      attachType: 'image',
      imagePath: '',
      pdfPath: '',
      pdfViewerVisible: false,
      viewer: undefined,
      options: {
        navbar: false,
        title: () => this.previewAttachInfo.name,
        toolbar: {
          zoomIn: true,
          zoomOut: true,
          oneToOne: true,
          reset: true,
          prev: false,
          play: {
            show: false
          },
          next: false,
          rotateLeft: true,
          rotateRight: true,
          flipHorizontal: true,
          flipVertical: true
        }
      },
      supportFileList: {
        image: [
          'jpeg',
          'gif',
          'svg+xml',
          'png',
          'bmp'
        ],
        application: [
          'pdf'
        ]
      },
      loading: undefined
    }
  },
  props: {
    previewAttachId: {
      type: Number,
      default: 0
    }
  },
  components: {
    Viewer
  },
  methods: {
    previewAttach() {
      this.loading = this.$loading({
        lock: true,
        text: '正在准备文件，请稍候...'
      })
      if (this.previewAttachId > 0) {
        fileInfo(this.previewAttachId).then(response => {
          if (response.status >= 200 && response.status < 300) {
            this.previewAttachInfo = response.data
            var config = {
              onDownloadProgress: progressEvent => {
                var progressPersent = ((progressEvent.loaded * 0.75) / this.previewAttachInfo.size * 100 | 0)
                this.loading.text = progressPersent < 100 ? `下载中(${progressPersent}%)...` : '处理中，请稍候...'
              }
            }
            var typeInfo = this.previewAttachInfo.fileType.split('/')
            if (this.supportFileList[typeInfo[0]] !== undefined) {
              if (this.supportFileList[typeInfo[0]].indexOf(typeInfo[1]) > -1) {
                downloadFile(this.previewAttachId, config).then(response => {
                  if (response.status >= 200 && response.status < 300) {
                    if (this.previewAttachInfo.fileType.indexOf('image') > -1) {
                      // 图片格式
                      this.imagePath = response.data
                      this.attachType = 'image'
                      this.showImagePreview()
                      return
                    } else {
                      var arr = response.data.split(',')
                      var mime = arr[0].match(/:(.*?);/)[1]
                      var bstr = atob(arr[1])
                      var n = bstr.length
                      var u8arr = new Uint8Array(n)
                      while (n--) {
                        u8arr[n] = bstr.charCodeAt(n)
                      }
                      var fileBlob = new Blob([u8arr], { type: mime })
                      if (this.previewAttachInfo.fileType.indexOf('pdf') > -1) {
                        this.pdfPath = './static/pdf/web/viewer.html?file=' + extendFunctions.getFileURL(fileBlob)
                        this.attachType = 'pdf'
                        this.pdfViewerVisible = true
                      } else {
                        this.$message({
                          message: '暂不支持该格式文件预览，请下载至本地查看。'
                        })
                      }
                      this.loading.close()
                    }
                  } else {
                    this.imagePath = ''
                    this.loading.close()
                  }
                }).catch(exception => {
                  this.imagePath = ''
                  this.loading.close()
                  console.error('下载失败！' + (exception.response.status !== 500 ? exception.response.data : '未知错误'))
                })
                return
              }
            }
            this.loading.close()
            this.$message({
              message: '暂不支持该格式文件预览，请下载至本地查看。'
            })
            return
          }
        }).catch(exception => {
          this.imagePath = ''
          this.loading.close()
          console.error('下载失败！' + (exception.response.status !== 500 ? exception.response.data : '未知错误'))
        })
      } else {
        this.loading.close()
      }
    },
    showImagePreview() {
      this.viewer.show()
      this.loading.close()
    },
    previewImages(handleRange) {
      console.log(handleRange.imageGroup().data)
    },
    inited(viewer) {
      this.viewer = viewer
      var that = this
      this.viewer.hidden = event => {
        that.$parent.attachViewerVisible = false
      }
    }
  }
}
</script>


